export default __webpack_public_path__ + "static/media/shop2.5a2ff9f3.jpg";